// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { RecordMapCategory } from "./record-map-category";

/**
 * RecordMap state.
 */
export class RecordMapSnapshot implements flatbuffers.IUnpackableObject<RecordMapSnapshotT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): RecordMapSnapshot {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsRecordMapSnapshot(
    bb: flatbuffers.ByteBuffer,
    obj?: RecordMapSnapshot,
  ): RecordMapSnapshot {
    return (obj || new RecordMapSnapshot()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsRecordMapSnapshot(
    bb: flatbuffers.ByteBuffer,
    obj?: RecordMapSnapshot,
  ): RecordMapSnapshot {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new RecordMapSnapshot()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  positionCount(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : 0n;
  }

  serviceCount(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : 0n;
  }

  bitmaskCount(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : 0n;
  }

  category(): RecordMapCategory {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : RecordMapCategory.Position;
  }

  isNewEntry(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  deviceKeyHash(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : 0n;
  }

  static startRecordMapSnapshot(builder: flatbuffers.Builder) {
    builder.startObject(6);
  }

  static addPositionCount(builder: flatbuffers.Builder, positionCount: bigint) {
    builder.addFieldInt64(0, positionCount, 0n);
  }

  static addServiceCount(builder: flatbuffers.Builder, serviceCount: bigint) {
    builder.addFieldInt64(1, serviceCount, 0n);
  }

  static addBitmaskCount(builder: flatbuffers.Builder, bitmaskCount: bigint) {
    builder.addFieldInt64(2, bitmaskCount, 0n);
  }

  static addCategory(builder: flatbuffers.Builder, category: RecordMapCategory) {
    builder.addFieldInt8(3, category, RecordMapCategory.Position);
  }

  static addIsNewEntry(builder: flatbuffers.Builder, isNewEntry: boolean) {
    builder.addFieldInt8(4, +isNewEntry, +false);
  }

  static addDeviceKeyHash(builder: flatbuffers.Builder, deviceKeyHash: bigint) {
    builder.addFieldInt64(5, deviceKeyHash, 0n);
  }

  static endRecordMapSnapshot(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createRecordMapSnapshot(
    builder: flatbuffers.Builder,
    positionCount: bigint,
    serviceCount: bigint,
    bitmaskCount: bigint,
    category: RecordMapCategory,
    isNewEntry: boolean,
    deviceKeyHash: bigint,
  ): flatbuffers.Offset {
    RecordMapSnapshot.startRecordMapSnapshot(builder);
    RecordMapSnapshot.addPositionCount(builder, positionCount);
    RecordMapSnapshot.addServiceCount(builder, serviceCount);
    RecordMapSnapshot.addBitmaskCount(builder, bitmaskCount);
    RecordMapSnapshot.addCategory(builder, category);
    RecordMapSnapshot.addIsNewEntry(builder, isNewEntry);
    RecordMapSnapshot.addDeviceKeyHash(builder, deviceKeyHash);
    return RecordMapSnapshot.endRecordMapSnapshot(builder);
  }

  unpack(): RecordMapSnapshotT {
    return new RecordMapSnapshotT(
      this.positionCount(),
      this.serviceCount(),
      this.bitmaskCount(),
      this.category(),
      this.isNewEntry(),
      this.deviceKeyHash(),
    );
  }

  unpackTo(_o: RecordMapSnapshotT): void {
    _o.positionCount = this.positionCount();
    _o.serviceCount = this.serviceCount();
    _o.bitmaskCount = this.bitmaskCount();
    _o.category = this.category();
    _o.isNewEntry = this.isNewEntry();
    _o.deviceKeyHash = this.deviceKeyHash();
  }

  unpackFields(...fields: string[]): RecordMapSnapshotT {
    const t = new RecordMapSnapshotT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("position_count")) {
      t.positionCount = this.positionCount();
    }
    if (fieldSet.has("service_count")) {
      t.serviceCount = this.serviceCount();
    }
    if (fieldSet.has("bitmask_count")) {
      t.bitmaskCount = this.bitmaskCount();
    }
    if (fieldSet.has("category")) {
      t.category = this.category();
    }
    if (fieldSet.has("is_new_entry")) {
      t.isNewEntry = this.isNewEntry();
    }
    if (fieldSet.has("device_key_hash")) {
      t.deviceKeyHash = this.deviceKeyHash();
    }
    return t;
  }
}

export class RecordMapSnapshotT implements flatbuffers.IGeneratedObject {
  constructor(
    public positionCount: bigint = 0n,
    public serviceCount: bigint = 0n,
    public bitmaskCount: bigint = 0n,
    public category: RecordMapCategory = RecordMapCategory.Position,
    public isNewEntry: boolean = false,
    public deviceKeyHash: bigint = 0n,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return RecordMapSnapshot.createRecordMapSnapshot(
      builder,
      this.positionCount,
      this.serviceCount,
      this.bitmaskCount,
      this.category,
      this.isNewEntry,
      this.deviceKeyHash,
    );
  }

  clone(): RecordMapSnapshotT {
    const obj = new RecordMapSnapshotT();
    obj.positionCount = this.positionCount;
    obj.serviceCount = this.serviceCount;
    obj.bitmaskCount = this.bitmaskCount;
    obj.category = this.category;
    obj.isNewEntry = this.isNewEntry;
    obj.deviceKeyHash = this.deviceKeyHash;
    return obj;
  }

  equals(other: RecordMapSnapshotT): boolean {
    if (this.positionCount !== other.positionCount) return false;
    if (this.serviceCount !== other.serviceCount) return false;
    if (this.bitmaskCount !== other.bitmaskCount) return false;
    if (this.category !== other.category) return false;
    if (this.isNewEntry !== other.isNewEntry) return false;
    if (this.deviceKeyHash !== other.deviceKeyHash) return false;
    return true;
  }
}

export function verifyRecordMapSnapshot(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 8);
    verifier.checkScalarField(tablePos, 6, 8);
    verifier.checkScalarField(tablePos, 8, 8);
    verifier.checkScalarField(tablePos, 10, 1);
    verifier.checkScalarField(tablePos, 12, 1);
    verifier.checkScalarField(tablePos, 14, 8);
  } finally {
    verifier.popDepth();
  }
}
